import { styled as muiStyled } from '@material-ui/core/styles';
import { Switch } from '@material-ui/core';
import styled from 'styled-components';
import React from 'react';

const IOSSwitch = muiStyled((props) => (
  <Switch focusVisibleClassName='.Mui-focusVisible' disableRipple {...props} />
))(({ theme }) => ({
  width: 33,
  height: 16,
  padding: 0,
  display: 'flex',
  '& .MuiSwitch-switchBase': {
    padding: 0,
    margin: 2,
    transitionDuration: '300ms',
    '&.Mui-checked': {
      transform: 'translateX(17px)',
      color: '#fff',
      '& + .MuiSwitch-track': {
        backgroundColor: '#283890',
        opacity: 1,
        border: 0
      }
    }
  },
  '& .MuiSwitch-thumb': {
    width: 12,
    height: 12,
    boxShadow: '0 2px 4px rgba(0,0,0,0.2)'
  },
  '& .MuiSwitch-track': {
    borderRadius: 16 / 2,
    backgroundColor: theme.palette.grey[400],
    opacity: 1,
    transition: theme.transitions.create(['background-color'], {
      duration: 500
    })
  }
}));

const Container = styled.div`
  display: flex;
  width: 100%;
  justify-content: space-between;
  align-items: center;
  margin: 0;
  & .label {
    color: #677b8b;
    font-size: 10px;
    font-weight: 700;
  }
  &.form {
    margin-top: 20px;
    & .label {
      font-size: 12px;
    }
  }
`;

export default function ({ label, checked, onChange, ...props }) {
  return (
    <Container {...props}>
      <div className='label'>{label || ''} </div>
      <IOSSwitch size='small' checked={checked} onChange={onChange} />
    </Container>
  );
}
